interface Colours {
  [index: string]: string
}

const colours: Colours = {
  audit: '#1cc3ee',
  track: '#007B98',
  explain: '#E61969',
  report: '#FFD70F',
  welcome: '#96A4B8',
  settings: '#9F9F9F',
}

export default colours
